import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { shoppingStepSlice } from './shoppingStepSlice.js';
import { contratStepSlice } from './contratStepSlice.js';
import { idSpotSlice } from './idSpotSlice.js';
import { livraisonSlice } from './livraisonSlice.js';
import { periodDatesSlice, periodHeuresSlice } from './periodSlice.js';
import { dureeSlice } from './dureeSlice.js';
import { panierSlice } from './panierSlice.js';
import { userDataSlice } from './userDataSlice.js';
import { commentaireSlice } from './commentaireSlice.js';
import { contratSlice } from './contratSlice.js';
import { showPanierSlice } from './showPanierSlice.js';
import { stockArticlesSlice } from './stockArticlesSlice.js';
import { spotsListSlice } from './spotsListSlice.js';
import { idSpotLocSlice } from './idSpotLocSlice.js';
import { accessoiresSlice } from './accessoiresSlice.js';
import { checkCGVSlice } from './checkCGVSlice.js';
import { langSlice } from './langSlice.js';
import dayjs from 'dayjs';

// set the date of the day (as global state default value)
/* let date = new Date();
let today = `${(date.getFullYear())}-${date.getMonth() + 1}-${date.getDate()}`; */

const today = dayjs();
/* 
// changed 15/7/24 : date mini = jour j
const tomorow = today.add(1, 'day');
const dateMini = tomorow.format('YYYY-MM-DD'); */
const dateMini = today.format('YYYY-MM-DD');
const userDatas = {
    found: false,
    id_client: 0,
    tel: "",
    email: "",
    prenom: "",
    nom: "",
    adresse: "",
    adresse_comp: "",
    cp: "",
    ville: "",
    pays: ""
}

//list of global states
let state = {
    shoppingStep: 0,
    contratStep: 1,
    idSpot: 0,
    idSpotLoc: 0,
    dates: [dateMini, dateMini],
    heures: [0, 0],
    duree: {},
    livraison: {},
    panier: [],
    userData: userDatas,
    commentaire: "",
    contrat: {},
    showPanier: false,
    stockArticles: [],
    spotsList: [],
    accessoires: [],
    checkCGV: [false, false],
    lang: "fr"
};

export const store = configureStore(
    {
        preloadedState: state,
        reducer: combineReducers({
            shoppingStep: shoppingStepSlice.reducer,
            contratStep: contratStepSlice.reducer,
            idSpot: idSpotSlice.reducer,
            idSpotLoc: idSpotLocSlice.reducer,
            dates: periodDatesSlice.reducer,
            heures: periodHeuresSlice.reducer,
            duree: dureeSlice.reducer,
            livraison: livraisonSlice.reducer,
            panier: panierSlice.reducer,
            userData: userDataSlice.reducer,
            commentaire: commentaireSlice.reducer,
            contrat: contratSlice.reducer,
            showPanier: showPanierSlice.reducer,
            stockArticles: stockArticlesSlice.reducer,
            spotsList: spotsListSlice.reducer,
            accessoires: accessoiresSlice.reducer,
            checkCGV: checkCGVSlice.reducer,
            lang: langSlice.reducer

        }),
    }
)
